module.exports = __webpack_public_path__ + "img/2.03f6081c.webp";